import React from "react";
import PersonalAttesa from "../Attesa";
import Carrello from "../Carrello";

const AddToCart = () => {
  const [activeState, setActiveState] = React.useState("attesa");

  const [formFields, setFormFields] = React.useState<any>({});

  const handleGoToNextPage = (formFieldData: any) => {
    setFormFields(formFieldData);
    setActiveState("carello");
  };

  return (
    <div>
      {activeState === "attesa" ? (
        <PersonalAttesa handleGoToNextPage={handleGoToNextPage} />
      ) : (
        <Carrello formFields={formFields} />
      )}
    </div>
  );
};

export default AddToCart;
